export default __webpack_public_path__ + "static/media/blue_pink_neon_200.232c6912.png";